export const HOME_TOUR_KEY = 'home';

// optional: the step is skipped when its target is not on the page (e.g. the "Wikis" section of an orga
// while no wiki exists).

export const homeTourSteps = [
  {
    target: 'home-next-event',
    title: 'Nächster Spieltag',
    description: 'Hier siehst du immer den nächsten anstehenden Spieltag auf einen Blick — Datum, Uhrzeit, aktuelle Anmeldezahlen und gebuchte Zusätze (z. B. Leihausrüstung).',
  },
  {
    target: 'home-prices',
    title: 'Preisliste',
    description: 'Eintritt je Gruppe und alle Zusätze (z. B. Leihausrüstung, BBs) mit ihren Preisen im Überblick.',
  },
  {
    target: 'home-wikis',
    title: 'Wikis',
    description: 'Hier findest du die Wikis des Vereins — z. B. Regeln, Anleitungen und Nachschlagewissen für den Spieltag. Sie sind auch offline auf deinem Gerät verfügbar.',
    optional: true,
  },
  {
    target: 'nav-home',
    mobileTarget: 'nav-home-mobile',
    title: 'Navigation — Startseite',
    description: 'Über dieses Icon kommst du jederzeit zurück zur Startseite.',
  },
  {
    target: 'nav-events',
    mobileTarget: 'nav-events-mobile',
    title: 'Navigation — Spieltage',
    description: 'Hier findest du alle Spieltage und kannst neue anlegen.',
  },
  {
    target: 'nav-statistics',
    mobileTarget: 'nav-statistics-mobile',
    title: 'Navigation — Statistiken',
    description: 'Hier siehst du Auswertungen und Statistiken über vergangene Spieltage.',
  },
  {
    target: 'nav-settings',
    mobileTarget: 'nav-settings-mobile',
    title: 'Einstellungen',
    description: 'Hier findest du Dark Mode, Passwort ändern, Icon-Legende — und die Möglichkeit, diese Rundtour jederzeit neu zu starten.',
  },
  {
    target: 'nav-settings',
    mobileTarget: 'nav-settings-mobile',
    title: 'Dokumentation',
    description: 'Außerdem findest du hier die ausführliche Dokumentation mit allen Details, Erklärungen und Anleitungen zu jedem Bereich. Schau da gerne auch mal rein, wenn du etwas nachschlagen willst.',
  },
];
